import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d68f1ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4d68f1ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d68f1ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer-copy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d68f1ca')) {
      api.createRecord('4d68f1ca', component.options)
    } else {
      api.reload('4d68f1ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4d68f1ca&scoped=true", function () {
      api.rerender('4d68f1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channel/order/index.vue"
export default component.exports